import { getMessaging, deleteToken } from 'firebase/messaging';
import { getApp } from './getApp.mjs';

const unregisterFCM = async () => {
  try {
    const app = getApp();
    const messaging = getMessaging(app);
    return await deleteToken(messaging);
  } catch (e) {
    return void 0;
  }
};

export { unregisterFCM };
//# sourceMappingURL=unregisterFCM.mjs.map
